'use client';

import React, { EventHandler, useEffect, useLayoutEffect } from 'react';
import useAccount from '@/lib/hooks/useAccount';
import PostLoginHeader from './PostLoginHeader';
import useIsCurrentPage from '@/lib/hooks/useIsCurrentPage';
import { useRouter } from 'next/navigation';
import toast from '@/components/atoms/toaster/helpers/toast';
import Typography from '@/components/atoms/typography';
import CountdownTimer from '@/components/atoms/countdown-timer';
import { useCartConfig } from '@/providers/cart-config/CartConfigContext';

const HeaderTastic = ({ data }: any) => {
  const { loggedIn, account } = useAccount();
  const { setEnableCartAU, setEnableCartNZ } = useCartConfig();
  const status = account?.onboarding_workflow_status === 'MemberRegistered';
  const loginPage = useIsCurrentPage(['/au/login/', '/nz/login/']);
  
  // Set cart configuration from data
  useEffect(() => {
    if (data?.enableCartAU !== undefined) {
      setEnableCartAU(data.enableCartAU);
    }
    if (data?.enableCartNZ !== undefined) {
      setEnableCartNZ(data.enableCartNZ);
    }
  }, [data?.enableCartAU, data?.enableCartNZ, setEnableCartAU, setEnableCartNZ]);

  const showLogoutWarning = (e: CustomEvent<{ countDownTimeSec: number }>) => {
    const ts = e.detail.countDownTimeSec;
    const logoutWarningTimeInSeconds = ts;
    toast.warning(
      <div className="mr-2 flex items-center justify-between gap-4">
        <Typography>{`You are about to logout, please login to continue.`}</Typography>
        <CountdownTimer initialTime={logoutWarningTimeInSeconds} />
      </div>,
      {
        position: 'top-right',
        duration: logoutWarningTimeInSeconds * 1000,
        wrapperClassName: 'h-full',
        style: {
          display: 'flex',
          height: '100px',
          backgroundColor: '#F7F7F7',
        },
        toastId: 'count-down-timer',
        id:'count-down-timer',
        showbackdrop: true,
      },
    );
  };


  useLayoutEffect(() => {
    window.addEventListener('SHOW_LOGOUT_WARNING', showLogoutWarning as EventHandler<any>);
    return () => {
      window.removeEventListener('SHOW_LOGOUT_WARNING', showLogoutWarning as EventHandler<any>);
    };
  }, []);

  if (loggedIn || !loginPage) {
    return <PostLoginHeader data={data} />;
  } else {
    return "";
  }
};

export default HeaderTastic;